import script from "./AllergyModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllergyModule.vue?vue&type=script&setup=true&lang=ts"

import "./AllergyModule.vue?vue&type=style&index=0&id=37143473&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37143473"]])

export default __exports__